

module.exports = function () {
    const media = window.matchMedia('(min-width: 1024px)')
    if (media.matches) {
        const sections = document.querySelectorAll(".anchor-underline");

        window.addEventListener("scroll", navHighlighter);

        function navHighlighter() {

            let scrollY = window.pageYOffset;

            sections.forEach((current, index) => {
                const sectionHeight = current.offsetHeight;
                const sectionTop = current.offsetTop - 200;
                const nextSection = ( sections[index + 1] ) ? sections[index + 1].offsetTop - 200 : sectionTop + sectionHeight;
                sectionId = current.getAttribute("id");

                // console.log(scrollY, sectionTop, nextSection);
                
                if (
                    scrollY > sectionTop &&
                    scrollY <= nextSection
                ) {
                    // console.log(document.querySelector("header nav ul a[href*=" + sectionId + "]"));
                    document.querySelector("header nav ul a[href*=" + sectionId + "]")?.classList.add("active");
                } else {
                    // console.log(document.querySelector("header nav ul a[href*=" + sectionId + "]").classList.contains('active'))
                    // if ( !document.querySelector("header nav ul a[href*=" + sectionId + "]").classList.contains('active') ) {
                        document.querySelector("header nav ul a[href*=" + sectionId + "]")?.classList.remove("active");
                    // }
                }
            });
        }
        $(window).scroll(function () {
            $(".contact-header").removeClass("active");
            if ($(window).scrollTop() + $(window).height() > ($(document).height())) {
                //you are at bottom
                $(".contact-header").addClass("active");
            }
        });

    };

};


